import { render, staticRenderFns } from "./SecurityClassificationModal.vue?vue&type=template&id=563d13e8&scoped=true"
import script from "./SecurityClassificationModal.vue?vue&type=script&lang=js"
export * from "./SecurityClassificationModal.vue?vue&type=script&lang=js"
import style0 from "./SecurityClassificationModal.vue?vue&type=style&index=0&id=563d13e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d13e8",
  null
  
)

export default component.exports